import classNames from 'classnames'
import React from 'react'

import SubStep from '~/components/substep'

import { Actions, Button } from './checkout-step.styles'

import type { ReactNode } from 'react'

type Props = {
  active: boolean
  canEdit: boolean
  canProceed?: boolean
  children: ReactNode
  number: number
  onClickEditStep?: () => void
  proceed?: () => void
  title: string
  className?: string
  buttonText?: string
  adjacentActionButton?: boolean
}

const CheckoutStep = ({
  active,
  canEdit,
  children,
  number,
  onClickEditStep,
  title,
  canProceed,
  proceed,
  className,
  buttonText = 'Continue',
  adjacentActionButton,
}: Props) => {
  const classes = classNames('checkout-step', className)

  if (active) {
    return (
      <SubStep
        state="active"
        className={classes}
        number={number}
        title={title}
        adjacentActionButton={adjacentActionButton}
      >
        {children}
        {proceed && (
          <Actions>
            <Button disabled={!canProceed} onClick={proceed}>
              {buttonText}
            </Button>
          </Actions>
        )}
      </SubStep>
    )
  }

  if (canEdit) {
    return (
      <SubStep
        state="inactive"
        className={classes}
        number={number}
        onClick={onClickEditStep}
        title={title}
        adjacentActionButton={adjacentActionButton}
      >
        {children}
      </SubStep>
    )
  }

  return (
    <SubStep
      state="incomplete"
      className={classes}
      number={number}
      title={title}
      adjacentActionButton={adjacentActionButton}
    />
  )
}

export default CheckoutStep
